import { DocumentListPage } from './DocumentListPage';
import { withDocumentListPage } from './withDocumentListPage';

const ConnectedDocumentListPage = withDocumentListPage(DocumentListPage);

export { ConnectedDocumentListPage as DocumentListPage };
